import styled from 'styled-components';

export const PendingSessionsListContainer = styled.ul`
  margin-top: 25px;
  padding: 0;
  list-style: none;
`;
